<template>
  <div>
<!--    <el-select-->
<!--      class="search-el"-->
<!--      size="mini"-->
<!--      v-model="query.category_id"-->
<!--      placeholder="请选择"-->
<!--      clearable-->
<!--    >-->
<!--      <el-option label="全部分类" value=""></el-option>-->
<!--      <el-option-->
<!--        v-for="item in categoryList"-->
<!--        :key="item.id"-->
<!--        :label="item.name"-->
<!--        :value="item.id"-->
<!--      >-->
<!--      </el-option>-->
<!--    </el-select>-->
    <el-input
      class="search-el"
      size="mini"
      v-model="query.title"
      clearable
      placeholder="请输入标题"
    ></el-input>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.teacher_id"
      placeholder="请选择"
      clearable
      filterable
    >
      <el-option label="全部讲师" value=""></el-option>
      <el-option
        v-for="item in teacherList"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>
    <el-button type="primary" size="mini" @click="toCreate()"> 添加 </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="3%"
        ></el-table-column>
        <el-table-column label="标题" align="center" min-width="25%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toCreate(row.id)">
              <div>{{ row.title }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="图片" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <div v-if="row.images">
            <img
              v-for="(item,index) in row.images"
              :src="item.img"
              :key="index"
              style="width: 40px"
              alt=""
            />
            </div>
          </template>
        </el-table-column>

        <el-table-column label="视频" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <el-button v-if="row.media_url !== ''"
              type="text"
              size="small"
              @click="previewVideo(row.media_url)"
            >
              <div>查看</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="排序" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateSort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>


        <el-table-column
          prop="updated_at"
          label="更新时间"
          align="center"
          min-width="12%"
        ></el-table-column>


        <el-table-column label="讲师" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ filterTeacher(row.teacher_id) }}</div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="small" @click="del(row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="查看评论"
      :visible.sync="comment.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="80%"
    >
      <!--列表-->
      <el-table
        border
        :data="comment.result.data"
        highlight-current-row
        v-loading="comment.listLoading1"
        style="..."
      >
        <el-table-column label="昵称" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <div>{{ filterNickname(row.user_id) }}</div>
          </template>
        </el-table-column>

        <el-table-column label="头像" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <img :src="filterAvatar(row.user_id)" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column
          label="评论内容"
          prop="contents"
          align="center"
          min-width="25%"
        >
        </el-table-column>

        <el-table-column label="评论对象" align="center" min-width="25%">
          <template slot-scope="{ row }">
            <span v-if="row.parent_id == 0">视频</span>
            <span v-if="row.parent_id > 0"
              >评论：{{ filterParentComment(row.parent_id) }}</span
            >
          </template>
        </el-table-column>

        <el-table-column label="显示状态" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.show == 1" style="color: #67c23a"
                ><i class="el-icon-circle-check"></i> 显示</span
              >
              <span v-else style="color: #909399"
                ><i class="el-icon-circle-close"></i> 隐藏</span
              >
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px"
                @click="
                  row.show == 1
                    ? updateCommentShow(row.id, 0)
                    : updateCommentShow(row.id, 1)
                "
              >
                {{ row.show == 1 ? "隐藏" : "显示" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="created_at"
          label="发布时间"
          align="center"
          min-width="14%"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="small" @click="delComment(row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="showReplies(comment.query.object_id)"
        :current-page.sync="comment.query.page"
        :page-size="comment.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="comment.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="视频"
      :visible.sync="preview.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="closeVideo"
      width="50%"
    >
      <video-player-v
        :url="preview.url"
        v-if="preview.chooseOrgVisible"
      ></video-player-v>
    </el-dialog>
  </div>
</template>

<script>
import videoPlayerV from "@/components/videoPlayer.vue";

import {
  getList as getCommentList,
  updateShow as updateCommentShow,
  del as delComment,
} from "@/api/comment";

import { getTeacherList } from "@/api/common";

import { getList, del, updateSort } from "@/api/video";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      categoryList: [],
      categoryList2: [],
      teacherList: [],
      teacherList2: [],
      total: 0,
      query: {
        page: 1,
        limit: 10,
        type: 0,
        title: "",
        category_id: "",
        teacher_id: "",
      },

      comment: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page: 1,
          limit: 10,
          object_id: 0,
          type: 1,
        },
        result: {
          total: 0,
          data: [],
          userList: [],
          parentCommentList: [],
        },
      },

      preview: {
        chooseOrgVisible: false,
        url: "",
      },
    };
  },
  components: {
    videoPlayerV,
  },
  created: function () {
    // getCategoryList({ type_code: "video" }).then((response) => {
    //   this.categoryList = response.data;
    //   response.data.forEach((item) => {
    //     this.categoryList2[item.id] = item.name;
    //   });
    // });

    getTeacherList().then((response) => {
      this.teacherList = response.data;
      response.data.forEach((item) => {
        this.teacherList2[item.id] = item.name;
      });
    });

    this.getList();
  },
  methods: {
    previewVideo(url) {
      this.preview.chooseOrgVisible = true;
      this.preview.url = url;
    },
    closeVideo() {
      this.preview.chooseOrgVisible = false;
      this.preview.url = "";
    },

    // 弹窗关闭
    addEditFormOnClose() {
      this.comment.query.object_id = "";
      this.comment.chooseOrgVisible = false;

      this.comment.result.total = 0;
      this.comment.result.data = [];
      this.comment.result.userList = [];
      this.comment.result.parentCommentList = [];
    },
    showReplies(object_id) {
      this.comment.query.object_id = object_id;
      this.comment.chooseOrgVisible = true;
      getCommentList(this.comment.query).then((response) => {
        this.comment.result.total = response.data.total;
        this.comment.result.data = response.data.list;
        this.comment.result.userList = response.data.user_list;
        this.comment.result.parentCommentList =
          response.data.parent_comment_list;
      });
    },
    filterParentComment(id) {
      return this.comment.result.parentCommentList[id]["contents"];
    },
    filterNickname(user_id) {
      return this.comment.result.userList[user_id]["nickname"];
    },
    filterAvatar(user_id) {
      return this.comment.result.userList[user_id]["avatar"];
    },
    updateCommentShow(id, show) {
      updateCommentShow({
        id: id,
        show: show,
      }).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
          this.comment.result.total = 0;
          this.comment.result.data = [];
          this.comment.result.userList = [];
          this.comment.result.parentCommentList = [];
          this.showReplies(this.comment.query.object_id);
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
    delComment(id) {
      this.$confirm("此操作将删除该评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delComment({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.comment.result.total = 0;
            this.comment.result.data = [];
            this.comment.result.userList = [];
            this.comment.result.parentCommentList = [];
            this.showReplies(this.comment.query.object_id);
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    filterCategory(category_id) {
      return this.categoryList2[category_id];
    },
    filterTeacher(teacher_id) {
      return this.teacherList2[teacher_id];
    },
    toCreate(id) {
      this.$router.push({
        path: "/dynamic/info",
        query: {
          id: id,
        },
      });
    },

    getList() {
      this.loading = true;
      this.query.type = 2;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          updateSort({
            id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        del({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {},
};
</script>